
import { unstable_batchedUpdates } from "react-dom";
import React from "react";
import {MenuProps, message} from "antd";
import {getBoardCount, getNoteDoc, getNoteListCount, getNoteListExcludeHomeCount, isNoteIdExist} from "@model/note";
import {APP_WEB, APP_WEB_WWW, isWebApp} from "@/electron_interactive";
export type MenuItem = Required<MenuProps>["items"][number];
import Global from "@/global"
import {
    ARRAY_DEFAULT_PROJECT_ITEM_THUMB_BIG,
    BASE64_IMAGE_TRANSPARENT,
    BASE64_PLACEHOLDER,
    DEFAULT_CANVAS_BACKGROUND,
    DEFAULT_CANVAS_BACKGROUND_DARK,
    DEFAULT_NOTE_HEIGHT,
    DEFAULT_NOTE_WIDTH,
    DEFAULT_SHORTCUTS_CONFIG, HOME_LEFT_MENU_WIDTH, KEY_DRAW_LEFT_MENU_WIDTH,
    KEY_FILE_IMPORT_MODE,
    KEY_FILE_SIZE_LARGER_THEN_MODE,
    KEY_FILE_SIZE_SMALLER_THEN_MODE,
    KEY_FILE_SIZE_SPLIT,
    KEY_GLOBAL_SHORTCUTS_CONFIG,
    KEY_LAUNCH_TIMES,
    KEY_MACHINEID, KEY_PROJECT_THUMB_INDEX, LEFT_MENU_WIDTH, MAP_MONTH, MAX_CARD_COUNT,
    SYS_CONFIG_DEV_MODE,
    SYS_CONFIG_FREE_CARD_MODE,
    SYS_CONFIG_KEY_THEME,
    THEME_DARK
} from "@/Const";
import global from "@/global";
import {Random} from "roughjs/bin/math";
import * as PDFLib from "pdfjs-dist"
import html2canvas from "html2canvas";
import {t} from "i18next";
import { v4 as uuidv4 } from 'uuid';
import {getCardById, getCardCount, getCardDoc} from "@model/card";
import {ipcInvoke, ipcSend} from "@/common/ipc";
import clipboard from "clipboardy";
import {isMacOS} from "@tiptap/core";
import dayjs from "dayjs";
import type {WebviewTag} from "electron";
import {isZh} from "@/language";
import {dbGetHighlight} from "@model/highlight";
import {getEmbedLink} from "../@excalidraw/packages/excalidraw/element/embeddable";
import {toValidURL} from "../@excalidraw/packages/excalidraw/data/url";
import { parse, format } from 'date-fns';
import {ResolvablePromise} from "../@excalidraw/packages/excalidraw/utils";

PDFLib.GlobalWorkerOptions.workerSrc = (APP_WEB?"/":"")+"pdf/pdf.worker.js";//"https://cdn.bootcss.com/pdf.js/2.4.456/pdf.worker.js"

export const throttleRAF = <T extends any[]>(
    fn: (...args: T) => void,
    opts?: { trailing?: boolean }
) => {
    let timerId: number | null = null;
    let lastArgs: T | null = null;
    let lastArgsTrailing: T | null = null;

    const scheduleFunc = (args: T) => {
        timerId = window.requestAnimationFrame(() => {
            timerId = null;
            fn(...args);
            lastArgs = null;
            if (lastArgsTrailing) {
                lastArgs = lastArgsTrailing;
                lastArgsTrailing = null;
                scheduleFunc(lastArgs);
            }
        });
    };

    const ret = (...args: T) => {
        if (process.env.NODE_ENV === "test") {
            fn(...args);
            return;
        }
        lastArgs = args;
        if (timerId === null) {
            scheduleFunc(lastArgs);
        } else if (opts?.trailing) {
            lastArgsTrailing = args;
        }
    };
    ret.flush = () => {
        if (timerId !== null) {
            cancelAnimationFrame(timerId);
            timerId = null;
        }
        if (lastArgs) {
            fn(...(lastArgsTrailing || lastArgs));
            lastArgs = lastArgsTrailing = null;
        }
    };
    ret.cancel = () => {
        lastArgs = lastArgsTrailing = null;
        if (timerId !== null) {
            cancelAnimationFrame(timerId);
            timerId = null;
        }
    };
    return ret;
};

export const withBatchedUpdates = <
    TFunction extends ((event: any) => void) | (() => void)
    >(
    func: Parameters<TFunction>["length"] extends 0 | 1 ? TFunction : never
) =>
    ((event) => {
        unstable_batchedUpdates(func as TFunction, event);
    }) as TFunction;

export const withBatchedUpdatesThrottled = <
    TFunction extends ((event: any) => void) | (() => void)
    >(
    func: Parameters<TFunction>["length"] extends 0 | 1 ? TFunction : never
) => {
    // @ts-ignore
    return throttleRAF<Parameters<TFunction>>(((event) => {
        unstable_batchedUpdates(func, event);
    }) as TFunction);
};

export const distance2d = (x1: number, y1: number, x2: number, y2: number) => {
    const xd = x2 - x1;
    const yd = y2 - y1;
    return Math.hypot(xd, yd);
};

export const resolvablePromise = () => {
    let resolve!: any;
    let reject!: any;
    const promise = new Promise((_resolve, _reject) => {
        resolve = _resolve;
        reject = _reject;
    });
    (promise as any).resolve = resolve;
    (promise as any).reject = reject;
    return promise as ResolvablePromise<any>;
};

//获取参数
export function getQueryParam(variable:string) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i=0;i<vars.length;i++) {
        var pair = vars[i].split("=");
        if(pair[0] == variable){return decodeURI(pair[1]);}
    }
    return(false);
}

export function getUrlQueryParam(szUrl:any,paraName:any){
    if (!szUrl)return '';
    var arraySplits = szUrl.split('?');
    if (arraySplits.length < 2)return '';
    var query = arraySplits[1];
    var vars = query.split("&");
    for (var i=0;i<vars.length;i++) {
        var pair = vars[i].split("=");
        if(pair[0] == paraName){return decodeURI(pair[1]);}
    }
    return '';
}

/**
 * 字符串是否为空
 * @param szStr
 * @returns {boolean}
 */
export function isStringNullOrEmpty(szStr:any){
    return szStr == undefined || szStr == null || szStr == '' || szStr == 'null';
}

export function isDarkMode(){
    if (APP_WEB){
        return global.g_isDarkMode;
    }
    return localStorage.getItem(SYS_CONFIG_KEY_THEME) == THEME_DARK;
}

function uuid(){
    return uuidv4();
}

export function isBase64(szStr:any){
    if (!szStr || !isString(szStr))return false;
    return szStr.startsWith('data:');
}

export function getImagePathWithSvg(szImageName){
    return imgPathPerfix()+szImageName.replace('.svg','')+".svg";
}

export function getImagePathWithThemeSvg(szImageName){
    if (!szImageName)return;
    return getImagePathWithTheme(szImageName?.replace('.svg',''),true);
}

/**
 * 根据主题获取相应的图标
 * @param szImgName
 */
export function getImagePathWithTheme(szImgName:string,isSvg = false){
    if (!szImgName)return '';
    let szExt = 'png';
    if (isSvg || szImgName.endsWith('.svg')){
        szExt = 'svg';
    }
    szImgName = szImgName.replace('.svg','');
    return imgPathPerfix()+(isDarkMode()?(szImgName+`_white.${szExt}`):(szImgName+`.${szExt}`));
}

export function getImagePath(szImgName:string){
    if (szImgName.endsWith('.svg')){
        return imgPathPerfix() + szImgName;
    }
    return imgPathPerfix()+szImgName.replace('.png','')+".png";
}

export function getImagePathSvg(szImgName:string){
    return imgPathPerfix()+szImgName.replace('.svg','')+".svg";
}

//uuid
export function generateUUID() {
    // var d = new Date().getTime();
    // if (window.performance && typeof window.performance.now === "function") {
    //     d += performance.now(); //use high-precision timer if available
    // }
    // var uuid = 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    //     var r = (d + Math.random() * 16) % 16 | 0;
    //     d = Math.floor(d / 16);
    //     return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    // });
    // return uuid;
    return uuid();
}

export function generateUUID2() {
    // function S4() {
    //     return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    // }
    // return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
    return uuid().replaceAll('-','');
}

function generateUniqueID(length:number) {
    var array = new Uint32Array(2);
    window.crypto.getRandomValues(array);
    var id = (array[0] + array[1]).toString(36) + Math.random().toString(36).substring(2, length + 2);
    return id.substring(0, length);
}

//生成tree page 的ID ，12位.
export function generateRandomPageKey(){
    return generateUniqueID(12);//generateRandomMixedId(5+Math.random()*2);
}

//生成n位数字字母混合字符串
export function generateRandomMixedId(n) {
    var chars = ['0','1','2','3','4','5','6','7','8','9',
        'A','B','C','D','E','F','G','H','I','J','K','L','M',
        'N','O','P','Q','R','S','T','U','V','W','X','Y','Z',
    'a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z'];
    var res = "";
    for(var i = 0; i < n ; i++) {
        var id = Math.floor(Math.random()*chars.length);
        res += chars[id];
    }
    return res;
}

//生成n位数字字母混合字符串
export function generateRandomMixedIdNoNumber(n) {
    var chars = [
        'A','B','C','D','E','F','G','H','I','J','K','L','M',
        'N','O','P','Q','R','S','T','U','V','W','X','Y','Z',
        'a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z'];
    var res = "";
    for(var i = 0; i < n ; i++) {
        var id = Math.floor(Math.random()*chars.length);
        res += chars[id];
    }
    return res;
}

//生成发布的ID，带上当前登录的用户ID
export async function generateShortUUID() {
    const characters = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let shortUrl = "";
    for (let i = 0; i < 8; i++) {
        const randomIndex = Math.floor(Math.random() * characters.length);
        shortUrl += characters[randomIndex];
    }
    if (await isNoteIdExist(shortUrl)){
        await generateShortUUID();
    }
    return shortUrl;
}

export function getBase64ImageSize(base64:string) {
    return new Promise((resolve, reject) => {
        const image = new Image();
        image.onload = function() {
            resolve({
                width: image.width,
                height: image.height
            });
        };
        image.onerror = function() {
            // reject(new Error('Failed to load the image.'));

            resolve({width:0,height:0});
        };
        image.src = base64;
    });
}

/**
 * 图片的前缀
 */
export function imgPathPerfix(){
    if (APP_WEB || APP_WEB_WWW){
        return "/imgs/";
    }else if (isWebApp()){
        return "../imgs/";
    }
    return "./imgs/";
}

export function getCssPath(szFileName){
    if (APP_WEB || APP_WEB_WWW){
        return "/css/"+szFileName;
    }else if (isWebApp()){
        return "../css/"+szFileName;
    }
    return "./css/"+szFileName;
}


export function templatePathPerfix(){
    if (APP_WEB || APP_WEB_WWW){
        return "/template"
    }
    return "./template";
}

export function formatDate(lDate:any, fmt = 'yyyy-MM-dd') {
    if(lDate == undefined || lDate == null || lDate == '0')return '';
    let target = new Date(lDate)
    var o = {
        'M+': target.getMonth() + 1, //月份
        'd+': target.getDate(), //日
        'h+': target.getHours(), //小时
        'm+': target.getMinutes(), //分
        's+': target.getSeconds(), //秒
        'q+': Math.floor((target.getMonth() + 3) / 3), //季度
        S: target.getMilliseconds() //毫秒
    }
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (target.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    for (var k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
            fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
        }
    }
    return fmt
}

/**
 * info中的日期描述
 * @param time
 */
export function getInfoDateDesc(time:any){
    const date = new Date(time);
    let d = MAP_MONTH[`${date.getMonth()+1}`] + " " + String(date.getDate()).padStart(2,'0') + ", "+date.getFullYear();
    if (isZh()){
        d = `${date.getMonth()+1}` + "月 " + String(date.getDate()).padStart(2,'0') + ", "+date.getFullYear()
    }
    return d + "　　" + formatDate(time,'hh:mm');
}

/**
 * 日历的名称
 * @param journalTime
 */
export const getJournalName = (journalTime:any)=>{
    const date = new Date(journalTime);
    if (isZh()){
        return `${date.getMonth()+1}` + "月" + date.getDate() + "日, "+date.getFullYear()
    }
    return MAP_MONTH[`${date.getMonth()+1}`] + " " + date.getDate() + ", "+date.getFullYear()
}

export const stringToDateOrNull = (szDate:any)=>{
    szDate = szDate.trim().replace(/\s+/g, ' ');
    const formats = [
        'MMM d, yyyy',    // Aug 11, 2025
        'MMMM d, yyyy',   // August 11, 2025
        'MMMd,yyyy',      // AUG11,2025
        'MMM d , yyyy',   // AUG 11 , 2025
        'yyyyMMdd',       // 20250811
        'yyyy/MM/dd',     // 2025/08/11
        'M/d/yyyy',       // 8/11/2025
        'yyyy-MM-dd',     // 2025-08-11
        'MM-dd-yyyy',     // 08-11-2025
        'MM.dd.yyyy'      // 08.11.2025
    ];

    for (const fmt of formats) {
        try {
            const date = parse(szDate, fmt, new Date());
            if (!isNaN(date.getTime())) {
                return date;
            }
        } catch (e) {
            // 继续尝试下一个格式
        }
    }

    return null;
}


export const stringToDate = (szDate:any)=>{
    szDate = szDate.trim().replace(/\s+/g, ' ');
    const formats = [
        'MMM d, yyyy',    // Aug 11, 2025
        'MMMM d, yyyy',   // August 11, 2025
        'MMMd,yyyy',      // AUG11,2025
        'MMM d , yyyy',   // AUG 11 , 2025
        'yyyyMMdd',       // 20250811
        'yyyy/MM/dd',     // 2025/08/11
        'M/d/yyyy',       // 8/11/2025
        'yyyy-MM-dd',     // 2025-08-11
        'MM-dd-yyyy',     // 08-11-2025
        'MM.dd.yyyy'      // 08.11.2025
    ];

    for (const fmt of formats) {
        try {
            const date = parse(szDate, fmt, new Date());
            if (!isNaN(date.getTime())) {
                return date;
            }
        } catch (e) {
            // 继续尝试下一个格式
        }
    }

    return new Date();
}

//格式化显示的日期
export const formatDateCharDesc = (longDate:any)=>{
    if (!longDate)return '';
    const date = new Date(longDate);
    return `${MAP_MONTH[date.getMonth()+1]} ${date.getDate()}, ${date.getFullYear()}`;
}

// 使用every()方法  1包含2
export function containsAllEvery(set1, set2) {
    if (set2.length == 0)return false;
    return set2.every(item => set1.includes(item));
}

export function replaceLast(str, searchValue, replaceValue) {
    const index = str.lastIndexOf(searchValue);
    if (index === -1) return str;
    return str.substring(0, index) + replaceValue + str.substring(index + searchValue.length);
}

/**
 * 只格式化时分秒
 * @param date
 */
export function formatDateHms(date:any){
    let szTime = formatDate(date,'hh:mm:ss');
    if (szTime.startsWith('00:')){
        szTime = formatDate(date,'mm:ss');
    }
    return szTime;
}

export function removeHtmlTags(str) {
    if (isStringNullOrEmpty(str))return '';
    return str.replaceAll('&amp;','&').replace(/<[^>]*>/g, '').replaceAll('&nbsp;',' ');
}

export function removeHtmlTagsWithSpace(str) {
    if (isStringNullOrEmpty(str))return '';
    return str.replace(/<[^>]*>/g, ' ');
}

export function createNoteElementByNote(szName:string,szNoteDoc:string){
    szNoteDoc = szNoteDoc.replaceAll("<p></p>","<p>&nbsp;</p>");

    // return '<div style="padding: 4px 10px">'+
    //     '<span style=\'font-size: 16px;font-weight: 600;margin-bottom: 8px\'>'+szName+'</span>' +
    //     '<div style="height: 8px;line-height: 8px"></div>' + szNoteDoc+'</div>';
    var margin = '10px';
    if (szName.toLowerCase() == "untitled" || szName == t("Untitled")){
        szName = "";
        margin = '-4px';
    }
    var szColor = isDarkMode()?'#ffffff':'#333333';
    return '<style>html{font-size: 12px;color:'+szColor+';word-wrap: anywhere;padding-top: 8px;white-space: break-spaces} a{color:#3670F7} h1{font-size: 15px;margin:0px;padding:0px} h2{font-size: 14px;margin:0px;padding:0px} h3{font-size: 13px;margin:0px;padding:0px} p{margin: 0px 0;padding: 0;line-height: 20px;} ol{padding: 0 16px;margin-top: 4px;margin-bottom: 4px;} [data-type="taskItem"]{display: flex; list-style-type: none;margin-left: -22px;padding: 0;align-items: center;} ul{padding: 0 16px;margin-top: 4px;margin-bottom: 4px;} ul[data-type="taskList"] > li{display: flex;align-items: flex-start} ul li{margin: 2px 0;padding: 0;min-height: 26px;} [data-checked="true"]{text-decoration: line-through;color:#999999} blockquote{padding-left: 10px;border-left: 2px solid '+ (isDarkMode()?'#FFFFFF':'#0D0D0D') +';margin-left: 0px} hr{border-top: 1px solid #ddd !important;border-bottom: none!important;box-shadow: none!important;outline: none}</style><div style="padding: 4px 8px 4px 10px">'+
        '<span style=\'font-size: 16px;font-weight: 600;margin-top: 3px;display: block;margin-bottom: 8px\'>'+szName+'</span>' +
        '<div style="margin-top: '+margin+'"></div>' + szNoteDoc+'</div>'
}

/**
 * 创建pdf注记
 * @param nIndex
 * @param text
 */
export function createPdfAnnoTextElement(pdfData:any){
    if (pdfData.type == 'image'){
        return `<div style="position: fixed;z-index: 99999;left: 0;top: 0; display: flex;flex-direction: column;font-size: 12px;padding-left: 6px;padding-right: 6px;padding-bottom: 6px"><div style="display: flex;align-items: center"><span style="color: ${pdfData.color};border: 1px solid ${pdfData.color};width: 18px;height: 18px;display: flex;justify-items: center;justify-content: center;flex-shrink: 0">A</span><span style="margin-left: 4px;color: ${pdfData.color};text-overflow: ellipsis;white-space: nowrap;overflow: hidden">${"" + pdfData.name}</span></div><div style="height: 1px;background: #E4E4E4;margin-top: 4px"></div><div><img style="max-height: 200px;width: 100%;margin-top: 12px;height: auto;max-width: 100%" src="${pdfData.image}"></div></div>`
    }
    return `<div style="display: flex;flex-direction: column;font-size: 12px;padding-left: 6px;padding-right: 6px;padding-bottom: 6px"><div style="display: flex;align-items: center;flex-shrink: 0;"><span style="color: ${pdfData.color};border: 1px solid ${pdfData.color};width: 18px;height: 18px;display: flex;justify-items: center;justify-content: center;flex-shrink: 0">A</span><span style="margin-left: 4px;color: ${pdfData.color};text-overflow: ellipsis;white-space: nowrap;overflow: hidden">${"" + pdfData.name}</span></div><div style="height: 1px;background: #E4E4E4;margin-top: 6px;margin-left: -16px;margin-right: -16px"></div><blockquote style="margin-top:10px;margin-left:0px;margin-right:0px;padding-left:8px;border-left: 2px solid ${pdfData.color};"><span style="color: #00000080;margin-top: 4px">${pdfData.text}</span></blockquote></div>`
}

export async function noteToPng(appState:any,name:string,noteDataDoc:string,width=DEFAULT_NOTE_WIDTH,height=DEFAULT_NOTE_HEIGHT){
    const div = document.createElement('div');
    div.style.width = width + 'px';
    div.style.height = height + 'px';
    div.style.position = 'fixed';
    div.style.top = '0px';
    div.style.left = '0px';
    div.style.padding = '12px';
    div.style.zIndex = '-1';
    div.style.background = isDarkMode()?'#222222':'#FFFFFF';
    div.innerHTML = createNoteElementByNote(name,noteDataDoc).replace("word-wrap: anywhere;padding-top: 8px;white-space: break-spaces","");
    document.body.appendChild(div);

    const pngScale = 1 / global.g_canvasZoomValue;

    return new Promise((resolve, reject) => {
        html2canvas(div, {
            scale: pngScale,
        }).then((canvas) => {
            document.body.removeChild(div);
            resolve(canvas.toDataURL());
        }).catch((reject)=>{
            document.body.removeChild(div);
            resolve(BASE64_PLACEHOLDER);
        });
    })

}

export function replaceOriginNoteDocHtml(szName:string,szNoteDoc:string){
    var szColor = isDarkMode()?'#ffffff':'#333333';
    var margin = '10px';
    if (szName.toLowerCase() == "untitled"){
        szName = "";
        margin = '-10px';
    }
    const szReplace = '<style>html{font-size: 12px;color:'+szColor+';word-wrap: anywhere;padding-top: 8px} a{color:#3670F7} h1{font-size: 15px} h2{font-size: 14px} h3{font-size: 13px} p{margin: 8px 0;padding: 0;line-height: 20px;} ol{padding: 0 16px;margin-top: 4px;margin-bottom: 4px;} [data-type="taskItem"]{display: flex; list-style-type: none;margin-left: -22px;padding: 0;align-items: center;} ul{padding: 0 16px;margin-top: 4px;margin-bottom: 4px;} ul li{margin: 0;padding: 0;min-height: 26px;} blockquote{padding-left: 10px;border-left: 3px solid #0D0D0D;margin-left: 0px} hr{border-top: 1px solid #ffff00 !important;border-bottom: none!important;box-shadow: none!important;outline: none}</style><div style="padding: 4px 10px">'+
        '<span style=\'font-size: 16px;font-weight: 600;margin-bottom: 8px\'>'+szName+'</span>' +
        '<div style="margin-top: '+margin+'"></div>';
    if (szNoteDoc.indexOf("<style>html{font-size: 12px;color:") == 0){
        szNoteDoc = szNoteDoc.replace(szReplace,"");
        //移除最后一个div
        szNoteDoc = szNoteDoc.substring(0,szNoteDoc.length-6);
    }
    return szNoteDoc;
}

export function replaceNoteNameFromElementHtml(szName:string,szNoteDoc:string){

    const szReplace = "<span style=\'font-size: 16px;font-weight: 600;margin-bottom: 8px\'>"+szName+"</span>";
    let szHtml = szNoteDoc.replace(szReplace,"");
    return szHtml;
}

export function createElementNameByNote(szName:string){
    return "<span style='font-size: 18px;font-weight: 500'>"+szName+"</span>"
}

export function createFileElementHtml(szId:string,szFileName:string,szShowName:string,szImgBase64=''){
    if (!szFileName)szFileName = '';
    szFileName = szFileName.toLowerCase();

    if (isVideo(szFileName)){
        if (isWebApp()){
            return "<style>html body{margin: 0;padding: 0;width: 100%;height: 100%}</style><div class='file' style='position: relative'><video id="+szId+ " style='width: 100%;height: 100vh;object-fit:cover;background:black;position: absolute' controls><source src='"+szFileName+"' type='video/mp4'></video><div style='background: #3f434700;z-index: 999;width: 100%;height: 0vh;position: absolute;left: 0;top: 0;'></div></div>";
        }
        return "<style>html body{margin: 0;padding: 0;width: 100%;height: 100%}</style><div class='file' style='position: relative'><video id="+szId+ " style='width: 100%;height: 100vh;object-fit:cover;background:black;position: absolute' controls><source src='localfile://"+szFileName+"' type='video/mp4'></video><div style='background: #3f434700;z-index: 999;width: 100%;height: 0vh;position: absolute;left: 0;top: 0;'></div></div>";
    }else if (szFileName.endsWith('.pdf')){
        return "<style>html body{margin: 0;padding: 0;width: 100%;height: 100%}</style><div class='file' style='position: relative'><img style='width: 100%;height: 100%;margin-left: 0px;margin-top: 0px; border-radius: 8px' src='"+szImgBase64+"'></div>";
    }
    return "<style>html body{margin: 0;padding: 0;width: 100%;height: 100%}</style><div class='file' style='display: flex;flex-direction: column;align-items: center;height: 100vh;padding: 0px;background:"+(isDarkMode()?'#494949':'white')+"'><div style='background: "+(isDarkMode()?'#494949':'#FFFFFF')+";width: 100%;height: 100%;display: flex;align-items: center;justify-content: center;border-radius: 8px 8px 0 0'><img style='width: 86px;height: 86px' src='"+ imgPathPerfix()+ getFileIcon(szFileName) +"'/></div><div style='height: 1px;background: #efefef;width: 100%;margin: 12px -14px 0 -14px'></div></div>"
    // return "<style>html body{margin: 0;padding: 0;width: 100%;height: 100%}</style><div class='file' style='display: flex;flex-direction: column;align-items: center;height: 100vh;padding: 2px;background:"+(isDarkMode()?'white':'white')+"'><div style='background: #FBFBFB;;width: 100%;height: 70%;display: flex;align-items: center;justify-content: center;border-radius: 13px 13px 0 0'><img style='width: 56px;height: 56px' src='"+ imgPathPerfix()+ getFileIcon(szFileName) +"'/></div><div style='height: 1px;background: #efefef;width: 100%;margin: 12px -14px 0 -14px'></div><span style='text-align: center;font-size: 14px;height: 30%;display: block;display: flex;align-items: center;justify-content: center'>"+ (szShowName) +"</span></div>"
}

export function createVideoFileElementHtmlFromWeb(szUrl:string){
    return "<style>html body{margin: 0;padding: 0;width: 100%;height: 100%}</style><div class='file' style='position: relative'><video style='width: 100%;height: 100vh;object-fit:cover;background:black;position: absolute' controls><source src='"+szUrl+"' type='video/mp4'></video><div style='background: #3f434700;z-index: 9999;width: 100%;height: 70vh;position: absolute;left: 0;top: 0;pointer-events: none'></div></div>";
}

export function createPdfFileElementHtmlFromWeb(szUrl:string){
    return "<style>html body{margin: 0;padding: 0;width: 100%;height: 100%}</style><div class='file' style='position: relative'><img style='width: 100%;height: 100%;margin-left: 1px;margin-top: 1px; border-radius: 16px' src='"+szUrl+"'></div>";
}

/**
 * 导入文件的图标名称
 * @param szFileName
 */
export function getFileIcon(szFileName:string){
    if (!szFileName){
        return 'other.png';
    }
    if (isAudio(szFileName)){
        return 'mp3.png';
    }
    szFileName = szFileName.toLowerCase();
    const arraySplits = szFileName.split('.');
    const szExt = arraySplits[arraySplits.length -1];
    let szIcon = szExt+".png";
    if (szExt == 'docx' || szExt == 'doc'){
        szIcon = "doc.png";
    }else if (szExt == 'xlsx' || szExt == 'xls'){
        szIcon = "xls.png";
    }else if (szExt == 'pptx' || szExt == 'ppt'){
        szIcon = "ppt.png";
    }else if (szExt == 'zip' || szExt == 'rar' || szExt == "7z"){
        szIcon = "zip.png";
    }else if (szExt == 'psd'){
        szIcon = 'psd.png'
    }else if (szExt == 'xd'){
        szIcon = 'xd.png'
    }else if (szExt == 'rp'){
        szIcon = 'rp.png'
    }else if (szExt == 'sketch'){
        szIcon = 'sketch.png'
    }else if (szExt == 'xmind'){
        szIcon = 'xmind.png'
    }else if (szExt == 'gif'){
        szIcon = 'gif.png'
    }else if (szExt == 'numbers'){
        szIcon = 'numbers.png'
    }else if (szExt == 'pages'){
        szIcon = 'pages.png'
    }else if (szExt == 'txt'){
        szIcon = 'txt.png'
    }else if (szExt == 'html'){
        szIcon = 'html.png'
    }else if (szExt == 'fig'){
        szIcon = 'fig.png';
    }else if (szExt == 'key'){
        szIcon = 'key.png';
    }else if (szExt == 'md'){
        szIcon = 'md.png';
    }
    else{
        szIcon = 'other.png'
    }
    // const arraySupportExt = ["doc","docx","pdf","ppt","pptx","xls","xlsx","psd","mp3","mp4","zip","rar","7z"];
    // if (!arraySupportExt.some(p=>p == szExt)){
    //     szIcon = "other.png";
    // }
    return szIcon;
}

//点击下载图片
export const downloadImage = (imgUrl:string) => {
    return new Promise((resolve, reject) => {
        try{
            var canvas = document.createElement('canvas');
            var img = document.createElement('img');
            img.onload = function(e) {
                canvas.width = img.width;
                canvas.height = img.height;
                var context = canvas.getContext('2d');
                context?.drawImage(img, 0, 0, img.width, img.height);
                canvas.getContext('2d')?.drawImage(img, 0, 0, img.width, img.height);
                canvas.toBlob((blob)=>{
                    resolve(blobToBase64(blob));
                }, "image/jpeg");
            }
            img.onerror = function (e){
                reject();
            }
            img.src =imgUrl;
        }catch (ex){
            reject();
        }
    })
}

//点击下载图片
export const downloadImageBlob = (imgUrl:string) => {
    return new Promise((resolve, reject) => {
        try{
            var canvas = document.createElement('canvas');
            var img = document.createElement('img');
            img.onload = function(e) {
                canvas.width = img.width;
                canvas.height = img.height;
                var context = canvas.getContext('2d');
                context?.drawImage(img, 0, 0, img.width, img.height);
                canvas.getContext('2d')?.drawImage(img, 0, 0, img.width, img.height);
                canvas.toBlob((blob)=>{
                    resolve((blob));
                }, "image/jpeg");
            }
            img.onerror = function (e){
                reject();
            }
            img.src =imgUrl;
        }catch (ex){
            reject();
        }
    })
}

export function isFileHtml(szHtml:string){
    return szHtml?.indexOf("<div class='file'") >= 0;
}

export function isHTML(str) {
    return /<([A-Za-z][A-Za-z0-9]*)\b[^>]*>(.*?)<\/\1>/.test(str);
}

//如果是个数字就变成了数字******
export function getString(str){
    if (str){
        return str+'';
    }
    return str;
}

export const getTimezone = () => {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return timezone;
}

export const getFileName = (szPath:string)=>{
    if (isStringNullOrEmpty(szPath))return "";
    szPath = szPath.replaceAll("\\","/");
    const arraySplits = szPath.split("/");
    return arraySplits[arraySplits.length-1];
}

export const getFileNameWithoutExt = (szPath:string)=>{
    if (isStringNullOrEmpty(szPath))return "";
    szPath = szPath.replaceAll("\\","/");
    const arraySplits = szPath.split("/");
    const szFileName = arraySplits[arraySplits.length-1];
    const arrayS = szFileName.split(".");
    if (arrayS.length > 1){
        return szFileName.replace("."+arrayS[arrayS.length-1],"");
    }
    return arrayS[0];
}

/**
 * 取文件扩展名
 */
export const getFileNameExt  = (szPath:string)=>{
    if (isStringNullOrEmpty(szPath))return '';
    const arraySplits = szPath.split(".");
    return arraySplits[arraySplits.length-1];
}

export const isMd = (szPath:string)=>{
    if (!szPath)return false;
    szPath = szPath.toLowerCase();
    return szPath?.endsWith(".md");
}


export const isAudio = (szPath:string)=>{
    if (!szPath)return false;
    szPath = szPath.toLowerCase();
    return szPath?.endsWith(".mp3") || szPath.endsWith('.wav') || szPath.endsWith('.aac') || szPath.endsWith('.m4a');
}

export const isGif = (szPath:string)=>{
    if (!szPath)return false;
    return szPath.toLowerCase().endsWith('gif');
}

export function getAudioFilterExt(){
    return ['mp3','wav','aac','m4a']
}

export const isVideo = (szPath:string)=>{
    if (!szPath)return false;
    return szPath?.toLowerCase().endsWith(".mp4") || szPath?.toLowerCase().endsWith(".mov") || szPath?.toLowerCase().endsWith(".avi") || szPath?.toLowerCase().endsWith(".mpeg");
}

export const isMarkdown = (szPath:string)=>{
    if (!szPath)return false;
    return szPath.toLowerCase().endsWith('.md');
}

export const isPdf = (szPath:string)=>{
    if (!szPath)return false;
    return szPath?.toLowerCase().endsWith(".pdf");
}

export const isImage = (szPath:string)=>{
    szPath = szPath?.toLowerCase()??'';
    return szPath.endsWith('jpg') || szPath.endsWith('jpeg') || szPath.endsWith('png') || szPath.endsWith('bmp') || szPath.endsWith('svg') || szPath.endsWith('webp') || szPath.endsWith('avif') || szPath.endsWith('ico') || szPath.endsWith('.gif');
}

export const isShape = (szId:any)=>{
    return szId == 'rectangle' ||
        szId == 'roundedRectangle' ||
        szId == 'ellipse' ||
        szId == 'triangle' ||
        szId == 'diamond' ||
        szId == 'bubble' ||
        szId == 'parallelogram' ||
        szId == 'pentagram' ||
        szId == 'thickArrow'
}

export const getImageExt =()=>{
    return '.jpg,.jpeg,.bmp,.png,.webp,.avif,.ico,.svg,.gif';
}

/**
 * 是否在画布页
 */
export const isUrlInDraw = ()=>{
    return window.location.href.includes("/draw") || window.location.href.includes("/defaultProject")
}

export const checkTimeZone = () => {
    const now = new Date();
    const utc = new Date(now.getTime() + now.getTimezoneOffset() * 60000);
    const timeZoneOffset = utc.getTimezoneOffset();
    return timeZoneOffset === -480; // -480 minutes is UTC+8
};

/**
 * 是否是文件元素
 * @param element
 */
export const isFileElement = (element:any)=>{
    if (!element)return false;
    return element.type == 'iframe' && element.customData?.generationData?.type == 'file';
}
//其他文件
export const isOtherFileElement = (element:any)=>{
    if (!element)return false;
    const szFileName = element.customData?.generationData?.fileName;
    const isSupportFile = isAudio(szFileName) || isVideo(szFileName) || isPdf(szFileName);
    return isFileElement(element) && !isSupportFile;
}
export const isPdfFileElement = (element:any)=>{
    if (!element)return false;
    return element.type == 'iframe' && element.customData?.generationData?.type == 'file' && isPdf(element.customData?.generationData?.fileName);
}
export const isAudioFileElement = (element:any)=>{
    if (!element)return false;
    return element.type == 'iframe' && element.customData?.generationData?.type == 'file' && isAudio(element.customData?.generationData?.fileName);
}
export const isFileVideoElement = (element:any)=>{
    if (!element)return false;
    return element.type == 'iframe' && element.customData?.generationData?.type == 'file' && isVideo(element.customData?.generationData?.fileName);
}
export const isMdFileElement = (element:any)=>{
    if (!element)return false;
    return element.type == 'iframe' && element.customData?.generationData?.type == 'file' && isMd(element.customData?.generationData?.fileName);
}
export const isLiveVideoElement = (element:any)=>{
    if (!element)return false;
    return element.type == 'embeddable' && (element.customData?.generationData?.type == 'bilibili' || element.customData?.generationData?.type == 'youtube' || element.customData?.generationData?.type == 'baidu');
}
export const isNoteElement = (element:any)=>{
    if (!element)return false;
    return element.type == 'iframe' && element.customData?.generationData?.type == 'note'
}
export const isJournalElement = (element:any)=>{
    if (!element)return false;
    return element.type == 'iframe' && element.customData?.generationData?.libraryType == 'journal'
}
export const isPdfAnnoElement = (element:any)=>{
    if (!element)return false;
    return element.type == 'iframe' && element.customData?.generationData?.type == 'pdfAnno';
}
export const isCardAnnoElement = (element:any)=>{
    if (!element)return false;
    return element.type == 'iframe' && element.customData?.generationData?.type == 'cardAnno';
}
export const isVideoAnnoElement = (element:any)=>{
    if (!element)return false;
    return element.type == 'iframe' && element.customData?.generationData?.type == 'videoAnno';
}
export const isAudioAnnoElement = (element:any)=>{
    if (!element)return false;
    return element.type == 'iframe' && element.customData?.generationData?.type == 'audioAnno';
}
export const isAnnoElement = (element:any)=>{
    if (!element)return false;
    return isPdfAnnoElement(element) || isCardAnnoElement(element) || isVideoAnnoElement(element) || isAudioAnnoElement(element);
}

export const isAnnoType = (szType:any)=>{
    return szType == 'videoAnno' || szType == 'audioAnno' || szType == 'pdfAnno' || szType == 'cardAnno';
}

export const isLiveVideoType = (szType:any)=>{
    return szType == 'bilibili' || szType == 'baidu' || szType == 'youtube';
}
/**
 * 是link链接，并且文件存在....
 * @param element
 */
export const isLinkAndNotExist = (element:any)=>{
    if (isFileElement(element)){
        if (element.customData?.generationData?.isAbsolutePath){
            return element.customData?.generationData?.isFileExist == false;
        }
    }
    return false;
}


/**
 * 取pdf的第一张图...
 * @param path
 */
export const getPdfImageThumb = async (path: string) => {
    return new Promise(async (resolve, reject) => {
        try {
            const pdf = await PDFLib.getDocument(path).promise;
            const page = await pdf.getPage(1);
            const viewport = page.getViewport({scale: 1.5});
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');
            canvas.height = viewport.height;
            canvas.width = viewport.width;
            const renderContext = {
                canvasContext: context,
                viewport: viewport
            };
            await page.render(renderContext).promise;

            const imageData = canvas.toDataURL('image/png');

            context.clearRect(0,0,canvas.width,canvas.height);
            canvas.width = canvas.height = 0;

            return resolve(imageData)
        } catch (err) {
            resolve('')
        }

    })
}

export const getVideoImageThumb = (path:string)=>{
    return new Promise(async (resolve, reject) => {
        var video = document.createElement('video');
        try {
            video.style.width = video.style.height = '400px';
            video.src = path;
            video.style.position = 'absolute';
            video.style.left = '110px';
            video.style.top = '110px';
            video.style.zIndex = '0';
            video.style.opacity = '0';
            video.setAttribute('crossorigin', 'anonymous');

            video.addEventListener('loadeddata',function (){
                // 创建canvas元素
                try{
                    var canvas = document.createElement('canvas');
                    canvas.width = video.videoWidth / 1; // 缩略图的宽度，这里是视频宽度的1/4
                    canvas.height = video.videoHeight / 1; // 缩略图的高度，这里是视频高度的1/4
                    // video.pause();
                    // 绘制视频的当前帧到canvas上
                    canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
                    // 获取canvas的dataURL作为缩略图
                    var thumbnail = canvas.toDataURL('image/png');
                    document.body.removeChild(video);
                    resolve(thumbnail);
                }catch (e){
                    resolve(BASE64_IMAGE_TRANSPARENT);
                }finally {

                }
            })
            document.body.appendChild(video);
            await video.play();
        }catch (e){
            resolve(BASE64_IMAGE_TRANSPARENT);
        }finally {
            try {
                document.body.removeChild(video);
            }catch (e){}
        }
    })
}

/**
 * 遍历mindmap data
 * @param data
 * @param callback
 */
export const recursionMindmapData = async (data:any,callback:any)=>{
    await callback(data?.data ??{});
    if (data?.children?.length > 0){
        for (let i=0;i<data.children.length;i++){
            await recursionMindmapData(data.children[i],callback);
        }
    }
}

/**
 * 取mindmap的单独存在的文件
 * @param data
 */
export async function getMindmapFiles(data:any,isSingle=true){
    var arrayFiles:any = [];
    if (data){
        await traverseMap(data,0,async (node:any)=>{
            const extra = node.data?.extra;
            let isPdf = false;
            if (extra){
                if (extra.type == 'pdf' && extra.isSingle){
                    isPdf = true;
                    arrayFiles.push(extra)
                }
            }
            if (!isPdf && node.data.image){
                arrayFiles.push({
                    id:getFileNameWithoutExt(node.data.image),
                    fileName:getFileName(node.data.image)
                })
            }
        })
    }

    return arrayFiles;
}

/**
 * 取mindmap
 * @param data
 */
export async function getMindmapFiles0(data:any){
    var arrayFiles:any = [];
    if (data){
        await traverseMap(data,0,async (node:any)=>{
            const extra = node.data?.extra;
            let isNotImage = false;
            if (node.data.image){
                if (extra){
                    if (extra.type == 'pdf'){
                        isNotImage = true;
                        arrayFiles.push(extra);
                        //带上缩略图.
                        arrayFiles.push({
                            fileName:extra.id+'.png'
                        })
                        arrayFiles.push({
                            fileName:node.data.image.replace('localfile://','')
                        })
                        //注记中的图...
                        const pdfAnnos = await ipcInvoke('get-annotations',{fileId:extra.id});
                        if (pdfAnnos){
                            pdfAnnos.forEach(p=>{
                                if (p.type == 'image'){
                                    arrayFiles.push({
                                        fileName:p.id+'.png'
                                    })
                                }
                            })
                        }
                    }else if (extra.type == 'card'){
                        isNotImage = true;
                    }
                }
                if (!isNotImage && node.data.image){
                    arrayFiles.push({
                        id:getFileNameWithoutExt(node.data.image),
                        fileName:getFileName(node.data.image)
                    })
                }
            }
            if (node.data?.attachmentUrl || node.data.hyperlink){
                let szDeeplink = '';
                if (node.data.attachmentUrl){
                    if (isString(node.data?.attachmentUrl)){
                        szDeeplink = node.data.attachmentUrl;
                    }else{
                        szDeeplink = node.data.attachmentUrl?.url;
                    }
                }
                if (node.data.hyperlink){
                    szDeeplink = node.data.hyperlink;
                }

                if (isDeepLink(szDeeplink)){
                    const deeplink = decodeDeeplink(szDeeplink);
                    if (deeplink.type == 'library'){
                        const library:any = await getCardById(deeplink.id);
                        if (library){
                            if (library.type == 'audio' || library.type == 'file'){
                                arrayFiles.push({
                                    id:library.id,
                                    fileName:library.fileName
                                })
                            }else if (library.type == 'video' || library.type == 'pdf'){
                                arrayFiles.push({
                                    id:library.id,
                                    fileName:library.fileName
                                })
                                //缩略图
                                arrayFiles.push({
                                    fileName:library.id+'.png'
                                })
                                //注记中的图...
                                const pdfAnnos = await ipcInvoke('get-annotations',{fileId:library.id});
                                if (pdfAnnos){
                                    pdfAnnos.forEach(p=>{
                                        if (p.type == 'image'){
                                            arrayFiles.push({
                                                fileName:p.id+'.png'
                                            })
                                        }
                                    })
                                }
                            }
                        }
                    }
                }
            }
        })
    }

    return arrayFiles;
}

async function traverseMap(node, level,callback) {
    level = level || 0;
    var spacing = new Array(level + 1).join('  ');
    console.log(spacing + node.text);
    await callback(node);

    if (node.children) {
        for (let i=0;i<node.children.length;i++){
            await traverseMap(node.children[i], level + 1,callback);
        }
    }
}

export function streamBufsToBase64(buffer:any){
    const base64 = btoa(new Uint8Array(buffer).reduce((data, byte) => {
        return data + String.fromCharCode(byte);
    }, ''));
    return base64;
}

export function base64ToBlob(urlData, type) {
    let arr = urlData.split(',');
    let mime = arr[0].match(/:(.*?);/)[1] || type;
    // 去掉url的头，并转化为byte
    let bytes = window.atob(arr[1]);
    // 处理异常,将ascii码小于0的转换为大于0
    let ab = new ArrayBuffer(bytes.length);
    // 生成视图（直接针对内存）：8位无符号整数，长度1个字节
    let ia = new Uint8Array(ab);
    for (let i = 0; i < bytes.length; i++) {
        ia[i] = bytes.charCodeAt(i);
    }
    return new Blob([ab], {
        type: mime
    });
}

export function blobToBase64(blob){
    return new Promise((resolve, reject) => {
        let fileReader = new FileReader();
        fileReader.onload = function (res){
            resolve(res.target.result);
        }
        fileReader.readAsDataURL(blob);
    })
}


export async function imgToBase64(imgPath){
   return new Promise(((resolve, reject) => {
        const image = new Image();
        image.src = imgPath;
        image.onload = ()=>{
            const canvas = document.createElement("canvas");
            canvas.width = image.naturalWidth;
            canvas.height = image.naturalHeight;
            const ctx = canvas.getContext('2d');
            ctx?.drawImage(image,0,0);
            const base64 = canvas.toDataURL('image/png');
            return resolve(base64);
        }
        image.onerror = (err)=>{
            return reject(err);
        }
   }))
}

export function base64ImgToSVGSimple(imageBase64:any){
    var svgCode = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="120" height="120"><image xlink:href="'+imageBase64+'" height="120" width="120"/></svg>';
    return svgCode;
}

export function convertImageToSVG(imageSrc, callback) {
    const img = new Image();
    img.src = imageSrc;
    img.onload = function() {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);

        // 假设每个像素的颜色与SVG中的矩形颜色相对应
        let svgContent = '';
        for (let y = 0; y < canvas.height; y++) {
            for (let x = 0; x < canvas.width; x++) {
                const index = (y * canvas.width + x) * 4;
                const r = imageData.data[index];
                const g = imageData.data[index + 1];
                const b = imageData.data[index + 2];
                const a = imageData.data[index + 3];

                if (a > 0) { // 忽略透明像素
                    svgContent += `<rect x="${x}" y="${y}" width="1" height="1" fill="rgba(${r},${g},${b},${a})"/>\n`;
                }
            }
        }

        callback(`<svg width="${canvas.width}" height="${canvas.height}" xmlns="http://www.w3.org/2000/svg">\n${svgContent}</svg>`);
    };
}

function replaceStrokeColor(svgStr, newColor) {
    return svgStr.replace(
        /stroke\s*=\s*(['"])(?!(?:none)\1)(?:[a-zA-Z]+|#(?:[0-9a-fA-F]{3}){1,2})\1/gi,
        (match, quote) => `stroke=${quote}${newColor}${quote}`
    );
}

function replaceFillColor(svgStr, newColor) {
    return svgStr.replace(
        /fill\s*=\s*(['"])(?!(?:none)\1)(?:[a-zA-Z]+|#(?:[0-9a-fA-F]{3}){1,2})\1/gi,
        (match, quote) => `fill=${quote}${newColor}${quote}`
    );
}

// 修改 svg 颜色, svg 代表svg格式的字符串
export function changeSvgColor(svg, color) {
    svg = svg.replaceAll("black","#616264");
    let res = svg;
    // 先简单判断一下是否是一个svg
    if (/<svg/.test(svg)) {
        // .*？ 表示匹配任意字符到下一个符合条件的字符
        // if (/fill="#.*?"/.test(svg)) {
        //     // svg 有默认色
        //     res = svg.replace(/fill="#.*?"/g, `fill="${color}"`)
        // } else {
        //     // svg 无默认色
        //     // res = svg.replace(/<svg /g, `<svg fill="${color}"`)
        // }
        //
        // if (/stroke="#.*?"/.test(svg)) {
        //     // svg 有默认色
        //     res = res.replace(/stroke="#.*?"/g, `stroke="${color}"`)
        // }

        res = replaceStrokeColor(res,color);
        res = replaceFillColor(res,color);
    }
    //转义后的#等于%23，利用正则表达式，替换所有%23后6位为新的十六进制六位数。
    // let res = svg.replace(/%23[a-zA-Z0-9]{6}/g, color.replace("#", "%23")).replace(/currentColor/g, color);
    return res;
}

export function getSvgColor(svg){
    svg = svg.replaceAll("black","#616264");
    var fillRegex = new RegExp(/fill="([^"]*)"/g);//   查找第一个带#的   fill="#([^"]*)"
    var match = [...svg.matchAll(fillRegex)];
    if(match && match.length > 0){
        for (let i=0;i<match.length;i++){
            let item = match[i];
            if (item.length > 1 && item[1].indexOf("#") == 0){
                return item[1];
            }
        }
    }

    return 'black'
}

export function getSvgWidth(svg){
    var fillRegex = new RegExp(/width="([^"]\d)"/g);//   查找第一个带#的   fill="#([^"]*)"
    var match = [...svg.matchAll(fillRegex)];
    if(match && match.length > 0){
        for (let i=0;i<match.length;i++){
            let item = match[i];
            if (item.length > 1){
                let nW = parseInt(item[1]);
                if (nW < 10){
                    nW = 10;
                }
                return nW;
            }
        }
    }
    return 20;
}

export function getSvgHeight(svg){
    var fillRegex = new RegExp(/height="([^"]\d)"/g);//   查找第一个带#的   fill="#([^"]*)"
    var match = [...svg.matchAll(fillRegex)];
    if(match && match.length > 0){
        for (let i=0;i<match.length;i++){
            let item = match[i];
            if (item.length > 1){
                let nH = parseInt(item[1]);
                if (nH < 10){
                    nH = 10;
                }
                return nH;
            }
        }
    }
    return 0;
}

export function isJson(obj) {
    return typeof obj === 'object' && obj !== null && !Array.isArray(obj);
}


export function isNumber(str){
    var reg = RegExp(/^\d+$/);
    return reg.test(str);
}

export const isNumberOrFloat = (num) => {
    const regex = /^-?(\d+\.?\d*|\.\d+)$/;
    return regex.test(num);
};

export function filterNumericInput(value) {
    // 移除所有非数字和小数点的字符
    let filtered = value.replace(/[^0-9.]/g, '');

    // 确保最多只有一个小数点
    const dotCount = (filtered.match(/\./g) || []).length;
    if (dotCount > 1) {
        // 保留第一个小数点，移除后面的
        const firstDotIndex = filtered.indexOf('.');
        filtered = filtered.substring(0, firstDotIndex + 1) +
            filtered.substring(firstDotIndex + 1).replace(/\./g, '');
    }

    return filtered;
}

export function getSafeInt(value:any){
    let nValue = 0;
    try{
        nValue = parseInt(value,10);
        if (isNaN(nValue)){
            nValue = 0;
        }
    }catch (e){}
    return nValue;
}

export function getSafeFloat(value:any){
    let nValue = 0;
    try{
        nValue = parseFloat(value,10);
        if (isNaN(nValue)){
            nValue = 0;
        }
    }catch (e){}
    return nValue;
}

export function getSafeString(value:any){
    return (value??'') + '';
}
/**
 * 获取导入模式
 * askMe/importMode/linkMode
 */
export function getFileImportMode(size:any = 0){
    let importMode = localStorage.getItem(KEY_FILE_IMPORT_MODE) || 'importMode';
    if (importMode == 'advanced'){
        //高级选项..
        const fileSize = getIntValue(localStorage.getItem(KEY_FILE_SIZE_SPLIT), 50);
        if (size > fileSize*1024*1024){
            importMode = localStorage.getItem(KEY_FILE_SIZE_LARGER_THEN_MODE) || 'linkMode';
        }else{
            importMode = localStorage.getItem(KEY_FILE_SIZE_SMALLER_THEN_MODE) || 'importMode';
        }
    }
    return importMode;
}

export function getDrawLeftWidth(){
    let szWidth = localStorage.getItem(KEY_DRAW_LEFT_MENU_WIDTH);
    let nWidth = getSafeInt(szWidth);
    if (nWidth < LEFT_MENU_WIDTH){
        nWidth = LEFT_MENU_WIDTH;
    }
    return nWidth;
}

/**
 * 获取本地文件路径。。。如果是绝对路径就返回绝对地址，否则使用scheme
 * @param fileName
 */
export function getLocalFilePath(fileName:any,isAbsolutePath:boolean){
    if (isAbsolutePath || checkIfAbsolute(fileName)){
        if (isVideo(fileName) || isPdf(fileName) || isAudio(fileName) || isImage(fileName)){
            return 'file:///'+fileName;//需要加个scheme
        }
        return fileName;
    }

    if (checkIfAbsolute(fileName)){
        return fileName;
    }
    return 'localfile://'+fileName
}

export function svgStringToBase64(szSvg:any){
    if (!szSvg)return '';
    const szBase64 = btoa(unescape(encodeURIComponent(szSvg)));
    return szBase64;
}




export const checkIfAbsolute = (path) => {
    if (!path)return false;
    const isAbs = path && path[0] === '/' || path.match(/^[A-Za-z]:/);
    return isAbs;
};

/**
 * 引用的是文件绝对路径....
 * @param fileName
 */
export function isAbsoluteFilePath(fileName:any){
    return fileName?.includes('/') || fileName?.includes('\\');
}

/**
 * 从类型中获取 扩展名 不包含.
 * @param szMineType
 */
export function extFromMineType(szMineType:string){
    if (!szMineType)return '';
    if (szMineType.includes('/svg')){
        return 'svg';
    }
    const arraySplits = szMineType.split('/');
    if (arraySplits.length > 1){
        return arraySplits[1];
    }
    return '';
}


export function randomColor(){
    var random = new Random(Date.now());
    const szHex = "#"+Math.floor(random.next()*255).toString(16)+Math.floor(random.next()*255).toString(16)+Math.floor(random.next()*255).toString(16);
    console.log('random color '+szHex);
    return szHex;
}

export function hasPublishLicense(){
    // if (import.meta.env.DEV)return true;
    return !isEmptyStringObject(Global.g_userInfo?.publisherLicense);
}

export function hasPremiumLicense(){
    // if (import.meta.env.DEV)return true;
    return !isEmptyStringObject(Global.g_userInfo?.premiumLicense);
}

export function hasDesktopProPlusLicense(){
    // if (import.meta.env.DEV)return true;
    return !isEmptyStringObject(Global.g_userInfo?.desktopProPlusLicense);
}

export function hasDesktopLicense0(){
    // if (import.meta.env.DEV)return true;
    return !isEmptyStringObject(Global.g_userInfo?.desktopProLicense);
}


export function hasDesktopLicense(){
    if (import.meta.env.DEV)return true;
    if(Global.g_userInfo != undefined){
        if (APP_WEB_WWW){
            return Global.g_userInfo.hasDesktopProLicense;
        }
        return !isEmptyStringObject(Global.g_userInfo.desktopProLicense) || !isEmptyStringObject(Global.g_userInfo.desktopProPlusLicense) || !isEmptyStringObject(Global.g_userInfo.desktopProMaxLicense);//!isStringNullOrEmpty(Global.g_userInfo.commercialLicense)  ;
    }
    return false;
}

/**
 * 桌面基础版本？？
 */
export function hasDesktopBaseLicense(){
    if (Global.g_userInfo){
        return !isEmptyStringObject(Global.g_userInfo.desktopProBasicLicense);
    }
    return false;
}

/**
 * 是否有证书
 */
export function hasLicense(){
    if (import.meta.env.DEV)return true;
    if(Global.g_userInfo != undefined){
        if (APP_WEB_WWW){
            return Global.g_userInfo.hasDesktopProLicense;
        }
        return !isEmptyStringObject(Global.g_userInfo.desktopProLicense) || !isEmptyStringObject(Global.g_userInfo.desktopProPlusLicense) || !isEmptyStringObject(Global.g_userInfo?.publisher4BizLicense) || !isEmptyStringObject(Global.g_userInfo.premiumLicense) || !isEmptyStringObject(Global.g_userInfo.desktopProMaxLicense);//!isStringNullOrEmpty(Global.g_userInfo.commercialLicense)  ;
    }
    return false;
}

export function isEmptyStringObject(obj:any){
    return isStringNullOrEmpty(obj) || ((obj instanceof Object) && Object.keys(obj).length == 0)
}

/**
 * 只有desktoplicense的情况....
 */
export function hasOnlyDesktopLicense(){
    return !hasPublishLicense() && hasDesktopLicense();
}

/**
 * 可以免费创建CARD
 */
export function isFreeCreateCardMode(){
    return localStorage.getItem(SYS_CONFIG_FREE_CARD_MODE) == "true";
}

/**
 * 转整数
 * @param szValue
 */
export function getIntValue(szValue:any,nDefaultValue:any){
    if (!szValue)return nDefaultValue;
    try{
        return parseInt(szValue,10)
    }catch (e){

    }
    return nDefaultValue;
}

 /**
 * 是否超出免费限制
 */
 export async function hasBeyondFreeLimit(){
    const nCount:any = await getNoteListExcludeHomeCount();
    return !hasLicense() && !hasDesktopBaseLicense() && nCount > 1;
}

/**
 * 是否超出免费文本内容100限制
 */
export async function hasBeyondTextLimit(){
    if (!hasLicense() && !isFreeCreateCardMode() && !hasDesktopBaseLicense()){
        const nCount:any = await getCardCount();
        if (nCount > MAX_CARD_COUNT){
            window.showMessageBox(t("Upgrade required"),t("YouNeedToUpgradeCreateCard"),t("Cancel"),t("Learn more"),null,()=>{
                if (isZh()) {
                    ipcSend('open-url',import.meta.env.VITE_HTTP_PURCHASE_PRICE_ZH)
                }else {
                    ipcSend('open-url', import.meta.env.VITE_HTTP_PURCHASE_PRICE);
                }
            })
            return true;
        }
        return false;
    }
    return false;
}

export async function hasBeyondBoardLimit(){
    if (!hasLicense() && !hasDesktopBaseLicense()) {
        let nCount: any = await getBoardCount();
        if (nCount >= 5) {
            window.showMessageBox(t("Upgrade required"), t("NeedUpgradeToMoreBoard"), t("Cancel"), t("Learn more"), null, () => {
                if (isZh()) {
                    ipcSend('open-url', import.meta.env.VITE_HTTP_PURCHASE_PRICE_ZH)
                } else {
                    ipcSend('open-url', import.meta.env.VITE_HTTP_PURCHASE_PRICE);
                }
            })
            return true;
        }
    }
    return false;
}

export function hasValidate(lic){
    if (lic == null || lic === undefined)return false;
    if(lic.periodType == 'forever'){
        return true;
    }else{
        var date = lic.endTime;//2024-04-29T01:51:28.000+00:00
    }
}

export function isString(str){
     return typeof str == 'string';
}

export function isIntType(obj){
     return typeof(obj) == 'number';
}

export function isUrl(szUrl:any){
    return /^((https|http|ftp|rtsp|mms)?:\/\/)[^\s]+/.test(szUrl)
}

export function isDevMode(){
    return localStorage.getItem(SYS_CONFIG_DEV_MODE) == 'true';
}

export function isSvg(szMimeType:any){
     if (!szMimeType)return false;
     szMimeType = szMimeType.toLowerCase();
     return szMimeType.includes('/svg') || szMimeType.endsWith('.svg');
}

// export function isMobileBrowser() {
//     const userAgent = navigator.userAgent || navigator.vendor || window.opera;
//     return /android|avantgo|blackberry|iemobile|ipad|iphone|ipod|opera mini|opera mobi|palm|pocket|psp|series(4|6)0|symbian|windows ce|windows phone|xda|xiino/i.test(userAgent)
// }

export function replaceIcon(key,value){
    if (key === 'icon'){
        return '';
    }else if (key == 'html'){
        return '';//笔记的html也不存。读取的时候重新加载...
    }
    return value;
}
//替换tree中的icon转成字符串
export function jsonToStringReplaceIcon(objJson:any){
    const szCanvasJson = JSON.stringify(objJson,replaceIcon);
    return szCanvasJson;
}

export const getCookies = () => {
    const allCookies = document.cookie.split('; ');
    const cookies:any = {};

    for (let i = 0; i < allCookies.length; i++) {
        const cookie = allCookies[i].split('=');
        const name = decodeURIComponent(cookie[0]);
        const value = decodeURIComponent(cookie[1]);
        cookies[name] = value;
    }

    return cookies;
};

export function isChinese(character:string) {
    return (/[\u4e00-\u9fa5]/).test(character);
}

/**
 * 是否是默认的背景色
 * @param szHex
 */
export function isDefaultBackgroundColor(szHex:string){
    return szHex == '#2C2C2C' || szHex == '#FFFFFF'
}

export const isZipFile = (file:any)=>{
    return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.onload = function (event){
            const arrayBuffer = event.target.result;
            const int8Array = new Uint8Array(arrayBuffer);
            if (int8Array[0] == 80 && int8Array[1] == 75){//P K
                resolve(true);
            }else{
                resolve(false);
            }
            console.log(arrayBuffer);
        }
        const slice = file.slice(0,100);
        reader.readAsArrayBuffer(slice);
    })
}

/**
 * 计算文本高度......
 * @param width
 * @param szContent
 */
export const calcTextHeight = (width:any,szContent:any)=>{
    if (!szContent)return 0;
    const div = document.createElement('div');
    div.style.width = width+'px';
    div.style.fontFamily = 'Popins';
    div.style.fontSize = '12px';
    div.innerHTML = szContent;
    div.style.position = 'absolute';
    div.style.zIndex = '0';
    div.style.left = '0';
    div.style.top = '0';
    document.body.appendChild(div);
    const nHeight = div.offsetHeight;
    document.body.removeChild(div);
    return nHeight;
}

/**
 * 计算文本高度......
 * @param width
 * @param szContent
 */
export const calcTextAreaHeight = (width:any,szContent)=>{
    if (!szContent)return 37;

    // const test = document.getElementById('div-test');
    // if(test){
    //     document.body.removeChild(test);
    // }

    const textArea = document.createElement('div');
    textArea.id = 'div-test';
    textArea.style.width = width+'px';
    textArea.style.fontFamily = 'Popins';
    textArea.style.fontSize = '12px';
    textArea.innerText = szContent;
    textArea.style.position = 'fixed';
    textArea.style.zIndex = '999990';
    textArea.style.left = '0';
    textArea.style.top = '40px';
    textArea.style.padding = '0';
    textArea.style.resize = 'none';

    textArea.style.overflowWrap ='anywhere';
    textArea.style.background = '#ff000000';
    // textArea.style.whiteSpace = 'pre';


    document.body.appendChild(textArea);

    textArea.style.height = 'auto';
    // textArea.style.height = textArea.scrollHeight + 'px';
    const nHeight = textArea.offsetHeight + 20;
    textArea.style.height = nHeight + 'px'
    document.body.removeChild(textArea);
    return nHeight;
}

/**
 * 计算文本高度......
 * @param width
 * @param szContent
 */
export const calcTextAreaInfoNotesHeight = (width:any,szContent:any)=>{
    if (!szContent)return 24;

    // const test = document.getElementById('div-test');
    // if(test){
    //     document.body.removeChild(test);
    // }

    const textArea = document.createElement('div');
    textArea.id = 'div-test';
    textArea.className = 'textarea-note';
    textArea.style.width = width+'px';
    textArea.style.fontFamily = 'Popins';
    textArea.style.fontSize = '16px';
    textArea.innerText = szContent;
    textArea.style.position = 'fixed';
    textArea.style.zIndex = '999990';
    textArea.style.left = '0';
    textArea.style.top = '40px';
    textArea.style.padding = '0 12px';
    textArea.style.margin = '8px 0';
    textArea.style.resize = 'none';

    textArea.style.overflowWrap ='anywhere';
    textArea.style.background = '#ff000000';
    // textArea.style.whiteSpace = 'pre';


    document.body.appendChild(textArea);

    textArea.style.height = 'auto';
    // textArea.style.height = textArea.scrollHeight + 'px';
    let nHeight = textArea.offsetHeight;
    textArea.style.height = nHeight + 'px'
    document.body.removeChild(textArea);
    if (nHeight < 24){
        nHeight = 24;
    }
    return nHeight;
}

export const calcCardTitleHeight = (width:any,szContent:any)=>{
    const textArea = document.createElement('textarea');
    textArea.id = 'div-test-test';
    textArea.style.width = width+'px';
    textArea.style.fontFamily = 'Helvetica Neue';
    textArea.style.fontWeight = '700';
    textArea.style.fontSize = '26px';
    textArea.innerText = szContent;
    textArea.style.position = 'fixed';
    textArea.style.zIndex = '999990';
    textArea.style.left = '0';
    textArea.style.top = '40px';
    textArea.style.padding = '0';
    textArea.style.resize = 'none';
    textArea.style.wordSpacing = 'break-word';

    textArea.style.overflowWrap ='anywhere';
    textArea.style.background = '#ff000000';
    // textArea.style.whiteSpace = 'pre';

    document.body.appendChild(textArea);
    textArea.style.height = '32px';
    const nHeight = textArea.scrollHeight;
    // textArea.style.height = nHeight + 'px'
    document.body.removeChild(textArea);
    return nHeight;
}

export const calcTextAreaHeight0 = (width:any,szContent)=>{
    if (!szContent)return 43;
    const textArea = document.createElement('textarea');
    textArea.style.width = width+'px';
    textArea.style.fontFamily = 'Popins';
    textArea.style.fontSize = '12px';
    textArea.value = szContent;
    textArea.style.position = 'fixed';
    textArea.style.zIndex = '999990';
    textArea.style.left = '0';
    textArea.style.height = 'auto';
    textArea.style.minHeight = '0px';
    textArea.style.top = '0';
    textArea.style.resize = 'none';
    textArea.style.padding = '0';
    textArea.style.overflowWrap ='wrap';
    document.body.appendChild(textArea);
    const nHeight = textArea.scrollHeight + 10;
    textArea.style.height = nHeight + 'px'
    // document.body.removeChild(textArea);
    return nHeight;
}

/**
 * 计算注记的高度
 * @param videoData
 */
export const calcVideoAnnoHeight = (videoData:any,width:any)=>{
    return new Promise(resolve => {
        const div = document.createElement('div');
        div.style.position = 'absolute';
        div.style.zIndex = '0';
        div.style.top = '0';
        div.style.opacity = '0';
        div.style.overflowWrap='anywhere';
        div.style.width = (width-24)+'px';

        if (videoData.title){
            const span = document.createElement('span');
            span.className = 'font-family-semi-bold';
            span.style.fontSize = '16px';
            span.innerText = videoData.title;
            div.appendChild(span);
        }
        const div1 = document.createElement('div');
        div1.style.marginTop = '10px';
        const span1 = document.createElement('span');
        span1.innerText = videoData.content;
        span1.style.fontSize = '14px';
        span1.style.marginTop='6px';
        div1.appendChild(span1);

        if (videoData.thumbImage){
            const img = document.createElement('img');
            img.style.width = '100%';
            img.style.height = 'auto';
            img.src = getLocalFilePath(videoData.thumbImage,false);
            img.onload = function (event){
                const nHeight = div.clientHeight;
                document.body.removeChild(div);

                resolve(nHeight + 56)
            }
            img.onerror = function (event, source, lineno, colno, error){
                const nHeight = div.clientHeight;
                document.body.removeChild(div);
                resolve(nHeight + 56)
            }
            div1.appendChild(img);
        }

        div.appendChild(div1);
        document.body.appendChild(div)
        if (!videoData.thumbImage){
            const nHeight = div.clientHeight;
            document.body.removeChild(div);
            resolve(nHeight + 48)
        }

        // const nHeight = div.clientHeight;
        // document.body.removeChild(div);
        // return nHeight  + 48;
    })

}

/**
 * 转图片到webp...
 * @param pngImageSrc
 * @param quality
 */
export function convertImageToWebp(pngImageSrc:string, quality=100) {
    if (pngImageSrc.startsWith('data:image/svg+xml')){
        return base64ToBlob(pngImageSrc,'image/svg+xml');
    }
    return new Promise( (resolve, reject) => {
        const img = new Image();
        img.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);
            canvas.toBlob(async (blob) => {
                if (blob) {
                    resolve(blob);
                } else {
                    reject('Canvas to Blob conversion failed');
                }
            }, 'image/webp', quality);
        };
        img.onerror = reject;
        img.src = pngImageSrc;
    });
}

export function blobToFile(blob:any){
    var file = new File([blob],generateUUID2());
    return file;
}

/**
 * 格式化日期时间字符串
 *
 * @param value 待格式化的日期时间值，支持数字、字符串和Date类型，默认为当前时间戳
 * @param format 格式化字符串，默认为'YYYY-MM-DD HH:mm:ss'，支持格式化参数：YY：年，M：月，D：日，H：时，m：分钟，s：秒，SSS：毫秒
 * @returns 返回格式化后的日期时间字符串
 */
export function fromatDate(value: number | string | Date = Date.now(), format = 'YYYY-MM-DD HH:mm:ss'): string {
    try {
        let date: Date
        if (typeof value === 'number' || typeof value === 'string') {
            date = new Date(value)
            if (isNaN(date.getTime())) {
                throw new Error('Invalid date')
            }
        } else {
            date = value
        }
        function padZero(value: number, len: number = 2): string {
            // 左侧补零函数
            return String(value).padStart(len, '0')
        }
        function replacement(match: string) {
            switch (match) {
                case 'YYYY':
                    return padZero(date.getFullYear())
                case 'YY':
                    return padZero(date.getFullYear()).slice(2, 4)
                case 'MM':
                    return padZero(date.getMonth() + 1)
                case 'M':
                    return String(date.getMonth() + 1)
                case 'DD':
                    return padZero(date.getDate())
                case 'D':
                    return String(date.getDate())
                case 'HH':
                    return padZero(date.getHours())
                case 'H':
                    return String(date.getHours())
                case 'mm':
                    return padZero(date.getMinutes())
                case 'm':
                    return String(date.getMinutes())
                case 'ss':
                    return padZero(date.getSeconds())
                case 's':
                    return String(date.getSeconds())
                case 'SSS':
                    return padZero(date.getMilliseconds(), 3)
                default:
                    return match
            }
        }
        return format.replace(/(YYYY|YY|M{1,2}|D{1,2}|H{1,2}|m{1,2}|s{1,2}|SSS)/g, replacement)
    } catch (error) {
        console.error('Error formatting date:', error)
        return ''
    }
}

/**
 * 获取html的适合缩略图的部分...
 * @param szDoc
 */
export function getNoteDocThumbHtml(szDoc:string){
    if (!szDoc)return '';
    const div = document.createElement('div');
    div.style.position = 'absolute';
    div.innerHTML = szDoc;
    let szThumbHtml = '';
    for (let i=0;i<div.childNodes.length;i++){
        szThumbHtml += div.childNodes[i].outerHTML;
        const szContent = removeHtmlTags(szThumbHtml);
        if (szContent.length > 300){
            break;
        }
    }
    return szThumbHtml;
}

/**
 * 取第一个元素.
 * @param szDoc
 */
export function getNoteFirstHtmlForLeftCard(szDoc:string){
    const div = document.createElement('div');
    div.style.position = 'absolute';
    div.innerHTML = szDoc;
    let szContent = '';
    if (div.childNodes.length > 0){
        let szThumbHtml = div.childNodes[0].outerHTML;
        szContent = removeHtmlTags(szThumbHtml);
    }
    if (!szContent){
        szContent = t("Untitled");
    }
    return szContent;
}

export function createEmptyProject(id:string,szTitle:string){
    const lTime = Date.now();
    // if (!szTitle){
    //     szTitle = t("Untitled");
    // }
    let nIndex:any = getIntValue(localStorage.getItem(KEY_PROJECT_THUMB_INDEX), 0);
    if (nIndex < 0 || nIndex > ARRAY_DEFAULT_PROJECT_ITEM_THUMB_BIG.length) {
        nIndex = 0;
    }

    const canvas = {
        annotations:[],
        canvas:[
            {
                drawJson:{
                    appState:{scrollX:0,scrollY:0,viewBackgroundColor:isDarkMode()?DEFAULT_CANVAS_BACKGROUND_DARK:DEFAULT_CANVAS_BACKGROUND,zoom:{value:1}},
                    elements:[],
                    files:[],
                    type:'excalidraw',
                    version:2,
                },
                hasUpdate:true,
                isFolder:false,
                key:generateRandomPageKey(),
                subNotes:[],
                title:t("Board"),
                updateTime:lTime
            }
        ],
        info:{deviceId:localStorage.getItem(KEY_MACHINEID),screen:{height:screen.height,width:screen.width}},
        notes:[],
        pageSize:{type:'infinite',id:'whiteboard'}
    }
    var project = {
        createTime: lTime,
        deleteTime: 0,
        doc: canvas,
        favirateTime: 0,
        id: id,
        isDeleted: 0,
        isFavirated: 0,
        name: szTitle,
        searchName: szTitle,
        showName: szTitle,
        updateTime: lTime,
        saveTimes:0,
        viewTime:lTime,
        thumbUrl: ARRAY_DEFAULT_PROJECT_ITEM_THUMB_BIG[nIndex],
        img:'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII='
    }
    localStorage.setItem(KEY_PROJECT_THUMB_INDEX, (nIndex+1) % 12 + '');
    return project;
}

export const getVideoScale = async (url:string)=> {
    const video = document.createElement('video');
    video.setAttribute("width", "10");
    video.setAttribute("height", "10");
    video.setAttribute("style", "position: absolute;opacity: 0;z-index: -5;top: 0;");
    video.setAttribute("src", url);

    document.body.appendChild(video);

    const p = new Promise(function(resolve, reject) {
        video.addEventListener('canplay', function(e) {
            resolve({videoWidth:e.target.videoWidth, videoHeight:e.target.videoHeight})
        } )
    })
    const res = await p;
    document.body.removeChild(video);
    return res
}

export function getIntValueFromLocalStrage(szKey:string,nDefaultValue:number = 0){
    const szValue = localStorage.getItem(szKey);
    let nValue = nDefaultValue;
    if (szValue){
        try {
            nValue = parseInt(szValue);
        }catch (e){

        }
    }
    return nValue;
}

export function getYoutubeThumbUrl(szVideoId:any){
    return `https://img.youtube.com/vi/${szVideoId}/0.jpg`
}

export function fileToBase64(file:any) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () =>{
            resolve(reader.result);
        }
        reader.onerror = error => reject(error);
        reader.readAsDataURL(file);
    });
}

export function formatSize(nSize:any){
    if (nSize == null || nSize == undefined)return 0;
    let nKb = nSize / 1024;
    let nMb = nKb/1024;

    if (nMb > 1){
        return nMb.toFixed(0)+"MB";
    }
    if (nKb > 1){
        return nKb.toFixed(0)+'KB'
    }
    return nSize.toFixed(0)+'B';
}

export function copyTextToClipboard(szText:any){
    clipboard.write(szText);
}

export function replaceLatexInParagraph(str: string): string {
    return str?.replace(/(<p[^>]*>)(.*?)<\/p>/gs, (match, openTag, inner) => {
        const replaced = inner.replace(
            /\$\$(.+?)\$\$|\$(?!\s)(?!\d+.*?\$\d)(.+?\S?)(?<!\s)\$/gs,
            (_, blockContent, inlineContent) => {
                const content = (blockContent ?? inlineContent ?? "").trim();
                return `<latex-inline id="${crypto.randomUUID()}" data-metadata="${content}" firstcreate="false" highlightimgurl="" ifhidden="false"></latex-inline>`;
            }
        );

        return `${openTag}${replaced}</p>`;
    });
}

export function migrateInlineCodeToOfficial(doc) {
    if (!doc)return;
    return doc.replace(/<span data-inline-code="true"[^>]*>(.*?)<\/span>/g, '<code>$1</code>')
}

export function createDeeplink(item:any){
    return createCopyLinkByLibraryItem(item,false);
}
/**
 * 创建库中的各种各种数据的deeplink----
 * @param item
 */
export function createCopyLinkByLibraryItem(item:any,hasTip=true,bgColor:any = null,scColor:any=null,extra:any = null){
    let szDeeplink = '';
    if (item.type == 'videoAnno' || item.type == 'audioAnno'){
        szDeeplink = createCopyLink("highlight", item.libraryId,'videoNote',item.id,null,null,hasTip,null,null,null,bgColor,scColor,extra);
    }else{
        szDeeplink = createCopyLink("library", item.id,item.type,null,null,null,hasTip,null,null,null,bgColor,scColor,extra);
    }
    return szDeeplink;
}

/**
 * 创建复制链接..
 *
 */
export function createCopyLink(type:string|'project'|'library'|'highlight',id:string,
                               childType:string|'board'|'card'|'journal'|'pdf'|'video'|'audio'|'file'|'videoNote'|null=null,childId:any=null,
                               elementType:any=null,elementId:any = null,hasTip=true,libraryId:any=null,nodeId:any=null,isFolder:any = null,bgColor = null,scColor = null,extra:any = null){
    let szUrl = 'noteey://open?type='+type+'&id='+id;
    if (childType){
        szUrl += '&childType='+childType;
    }
    if (childId){
        szUrl += '&childId='+childId;
    }
    if (elementType){
        szUrl += '&elementType='+elementType;
    }
    if (elementId){
        szUrl += '&elementId='+elementId;
    }
    if (libraryId){
        szUrl += '&libraryId='+libraryId;
    }
    if (nodeId){
        szUrl += '&nodeId='+nodeId
    }
    if (isFolder){
        szUrl += '&isFolder=true';
    }
    if (bgColor){
        if (bgColor != 'transparent' && bgColor != '#00000000'){
            szUrl += '&bg='+bgColor.replace('#','').toLowerCase();
        }

    }
    if (scColor){
        if (scColor != 'transparent' && scColor != '#00000000'){
            szUrl += '&sc='+scColor.replace('#','').toLowerCase();
        }
    }
    if (extra){
        const arrayKeys = Object.keys(extra);
        let szParams = '';
        for (let i=0;i<arrayKeys.length;i++){
            szParams += `&${arrayKeys[i]}=${extra[arrayKeys[i]]}`
        }
        szUrl += szParams;
    }
    //copy to clipboard
    if (hasTip){
        clipboard.write(szUrl);
        message.info(t("Link copied to clipboard"));
    }
    let nid = generateUniqueID(8);
    return szUrl;
}

/**
 * 解析deeplink
 * @param szUrl
 */
export function decodeDeeplink(szUrl:string){
    const szType = getUrlQueryParam(szUrl,'type');
    const szId = getUrlQueryParam(szUrl,'id');
    const szChildType = getUrlQueryParam(szUrl,'childType');
    const szChildId = getUrlQueryParam(szUrl,'childId');
    const szElementType = getUrlQueryParam(szUrl,'elementType');
    const szElementId = getUrlQueryParam(szUrl,'elementId');
    const szLibraryId = getUrlQueryParam(szUrl,'libraryId');
    const szNodeId = getUrlQueryParam(szUrl,'nodeId');
    const isFolder = getUrlQueryParam(szUrl,'isFolder');
    let backgroundColor = getUrlQueryParam(szUrl,'bg');
    let strokeColor = getUrlQueryParam(szUrl,'sc');
    let szInsertNew = getUrlQueryParam(szUrl,'n');
    if (backgroundColor){
        backgroundColor = '#'+backgroundColor;
    }
    if (strokeColor){
        strokeColor = '#'+strokeColor;
    }
    return{
        type:szType,
        id:szId,
        childType:szChildType,
        childId:szChildId,
        elementType:szElementType,
        elementId:szElementId,
        libraryId:szLibraryId,
        nodeId:szNodeId,
        isFolder:isFolder,
        backgroundColor,
        strokeColor,
        isNew:szInsertNew == '1'
    }
}



export function isDeepLink(szUrl:string){
    if (!szUrl)return false;
    return szUrl.startsWith('noteey://open?type=');
}

/**
 * 是字幕的deeplink---不显示为deeplink
 * @param szUrl
 */
export function isTranscriptDeeplink(szUrl){
    return isDeepLink(szUrl) && szUrl.includes('transcript');
}

export function isCardDeeplink(szUrl:string){
    return isDeepLink(szUrl) && szUrl.includes('childType=card');
}
export function isPdfDeeplink(szUrl:string){
    return isDeepLink(szUrl) && szUrl.includes('childType=pdf');
}
export function isVideoDeeplink(szUrl:string){
    return isDeepLink(szUrl) && szUrl.includes('childType=video');
}
export function isFileDeeplink(szUrl:string){
    return isDeepLink(szUrl) && szUrl.includes('childType=file');
}
export function isHighlightDeeplink(szUrl:string){
    return isDeepLink(szUrl) && (szUrl.includes('childType=cardAnno') || szUrl.includes('childType=pdfAnno') || szUrl.includes('childType=audioAnno') || szUrl.includes('childType=videoAnno'));
}

/**
 * 首字母大写
 * @param szStr
 */
export function firstLetterUpper(szStr:string){
    if (szStr && szStr.length > 0){
        return szStr[0].toUpperCase()+szStr.substring(1)
    }
    return szStr;
}

/**
 * 从html 中获取图片路径...
 * @param html
 */
export function getImageFileNameListFromDoc(html:any) {
    const imgs:any = []
    if (!html)return imgs;
    const m = html.match(/src=[\'\"][^\'^\"]+[\'\"]/g)
    if(!m) return []
    for(let i=0; i<m.length; i ++){
        const url = m[i].replace(/^(src=[\'\"])([^\'^\"]+)([\'\"])$/, '$2')
        console.log('url: ', url);
        if (/^atom/.test(url)) {
            // const id = url.slice(7, -5)--这个固定扩展名.jpeg 才能用，写死的东西真无语了。
            // const arraySplits  = url.split('.');
            // const ext = arraySplits[arraySplits.length-1];
            // imgs.push(id+'.'+ext);
            const fileName = getFileName(url);
            imgs.push(fileName);
        }
    }
    return imgs
}

/**
 * 记录日志
 * @param szMsg
 */
export function logger(szMsg:any){
    console.log(szMsg);
    ipcSend('logger',{type:'info',msg:szMsg})
}

/**
 * 在frame框架里面的启动
 */
export function isInIFrameApp(){
    return (window.location.href.indexOf('/#/p') >= 0) || (window.location.href.indexOf('#p') >= 0)
}

export function isInDraw(){
    return window.location.href.includes('/draw') || window.location.href.includes('/home/defaultProject');
}

export function isInPageCardOrJournal(){
    return window.location.href.includes('/card') || window.location.href.includes('/journal');
}

export function isInJournal(){
    return window.location.href.includes('/journal');
}

export function isInPageLibrary(){
    return window.location.href.includes('/library');
}

export function isInPageTask(){
    return window.location.href.includes('/task');
}

export function isInPageTag(){
    return window.location.href.includes('/tag');
}

export function isInPageTagList(){
    return window.location.href.includes('/tagItemList');
}

export function isInProjectList(){
    return window.location.href.includes('/project')
}

export function isInPageProperties(){
    return window.location.href.includes('/property');
}

export function isInPageHighlight(){
    return window.location.href.includes('/highlight');
}


export function getCtrlOrAlt(szCmd:any){
    if (isMacOS()){
        return szCmd.replaceAll("Ctrl","⌘").replaceAll("Alt","Opt");
    }
    return szCmd;
}

export function getCtrlOrAltCmd(szCmd:any){
    if (isMacOS()){
        return szCmd.replaceAll("Ctrl","Cmd").replaceAll("Alt","Opt");
    }
    return szCmd;
}

/**
 * 是否是快捷键....
 * @param e
 * @param szShortcutName = 'quickNotes'|'newCard'|'globalSearch'
 */
export function isShortcuts(e:any,szShortcutName:any){
    //全局的快捷键.
    let shortcutsConfig:any = localStorage.getItem(KEY_GLOBAL_SHORTCUTS_CONFIG);
    if (shortcutsConfig){
        shortcutsConfig = JSON.parse(shortcutsConfig);
    }else{
        shortcutsConfig = DEFAULT_SHORTCUTS_CONFIG;
    }
    //自定义的快捷键，增加各种判断...
    let shortcutsKeyAnd:any = true;
    const globalSearchShortcut = shortcutsConfig.find(p=>p.name == szShortcutName);
    if (globalSearchShortcut.shortcuts.includes(getCtrlOrAltCmd('Ctrl'))){
        shortcutsKeyAnd = e.metaKey || e.ctrlKey;
    }
    if (globalSearchShortcut.shortcuts.includes(getCtrlOrAltCmd('Alt'))){
        shortcutsKeyAnd = shortcutsKeyAnd && e.altKey;
    }
    if (globalSearchShortcut.shortcuts.toLowerCase().includes('shift')){
        shortcutsKeyAnd = shortcutsKeyAnd && e.shiftKey;
    }
    const arraySplits = globalSearchShortcut.shortcuts.split('+');
    const szShortcutKey = arraySplits[arraySplits.length-1].replace(' ','').toLowerCase();
    if (szShortcutKey.length == 1){
        shortcutsKeyAnd = shortcutsKeyAnd && e.key.toLowerCase() == szShortcutKey;
    }
    if (!szShortcutKey){
        shortcutsKeyAnd = false;
    }
    return shortcutsKeyAnd;
}


export function getSelectionCoords(win) {
    win = win || window;
    var doc = win.document;
    var sel = doc.selection, range, rects, rect;
    var x = 0, y = 0;
    if (sel) {
        if (sel.type != "Control") {
            range = sel.createRange();
            range.collapse(true);
            x = range.boundingLeft;
            y = range.boundingTop;
        }
    } else if (win.getSelection) {
        sel = win.getSelection();
        if (sel.rangeCount) {
            range = sel.getRangeAt(0).cloneRange();
            if (range.getClientRects) {
                range.collapse(true);
                rects = range.getClientRects();
                if (rects.length > 0) {
                    rect = rects[0];
                }
                // 光标在行首时，rect为undefined
                if(rect){
                    x = rect.left;
                    y = rect.top;
                }
            }
            // Fall back to inserting a temporary element
            if ((x == 0 && y == 0) || rect === undefined) {
                var span = doc.createElement("span");
                if (span.getClientRects) {
                    // Ensure span has dimensions and position by
                    // adding a zero-width space character
                    span.appendChild( doc.createTextNode("\u200b") );
                    range.insertNode(span);
                    rect = span.getClientRects()[0];
                    x = rect.left;
                    y = rect.top;
                    var spanParent = span.parentNode;
                    spanParent.removeChild(span);

                    // Glue any broken text nodes back together
                    spanParent.normalize();
                }
            }
        }
    }
    return { x: x, y: y };
}

// 获取当前光标位置
const getCursortPosition = function (element) {
    var caretOffset = 0;
    var doc = element.ownerDocument || element.document;
    var win = doc.defaultView || doc.parentWindow;
    var sel;
    // 谷歌、火狐
    if (typeof win.getSelection != "undefined") {
        sel = win.getSelection();
        // 选中的区域
        if (sel.rangeCount > 0) {
            var range = win.getSelection().getRangeAt(0);
            // 克隆一个选中区域
            var preCaretRange = range.cloneRange();
            // 设置选中区域的节点内容为当前节点
            preCaretRange.selectNodeContents(element);
            // 重置选中区域的结束位置
            preCaretRange.setEnd(range.endContainer, range.endOffset);
            caretOffset = preCaretRange.toString().length;
        }
        // IE浏览器
    } else if ((sel = doc.selection) && sel.type != "Control") {
        var textRange = sel.createRange();
        var preCaretTextRange = doc.body.createTextRange();
        preCaretTextRange.moveToElementText(element);
        preCaretTextRange.setEndPoint("EndToEnd", textRange);
        caretOffset = preCaretTextRange.text.length;
    }
    return caretOffset;
}

export function countWords(text:any) {
    if (!text)return 0;
    text = text.trim();
    if (!text)return 0;
    // 使用正则表达式匹配中文字符，并计算总数
    const matches = text.match(/[\u4e00-\u9fa5]/g);
    let chineseWordCount = matches ? matches.length : 0;
    if (chineseWordCount > 0){
        chineseWordCount --;
    }
    // 分割空格并去除首尾空格，然后与中文字数相加
    const words = text.trim().split(/\s+/);
    return words.length + chineseWordCount;
}

export function isArray(obj) {
    return typeof obj === "object" && Array.isArray(obj);
}

export function isObject(obj){
    if (!obj)return false;
    return typeof obj === 'object';
}


export function isCardEmpty(szHtml:any){
    if (!szHtml)return true;

    if (szHtml == '<p></p>'){
        return true;
    }
    var reg = /<p[^>]*><\/p>/g
    var arrayRes = szHtml.match(reg);
    if (arrayRes && arrayRes.length == 1){
        return arrayRes[0] == szHtml;
    }
    return false;
}

export function isCardEmptyCard(card:any){
    return isStringNullOrEmpty(card.name) && isCardEmpty(card.doc);
}

export const isYoutubeUrl = (url: string) => {
    if (!url)return false;
    if (!isString(url))return false;
    const YOUTUBE_REGEX = /^(https?:\/\/)?(www\.|music\.)?(youtube\.com|youtu\.be|youtube-nocookie\.com)\/(?!channel\/)(?!@)(.+)?$/
    return url.match(YOUTUBE_REGEX)
}

export const isBilibiliUrl = (url:any)=>{
    if (!url)return false;
    if (!isString(url))return false;
    // const YOUTUBE_REGEX = /^(https?:\/\/)?(www\.|music\.)?(bilibili\.com|bilibili\.be|bilibili-nocookie\.com)\/(?!channel\/)(?!@)(.+)?$/
    // return url.match(YOUTUBE_REGEX)
    return url.includes("bilibili") || url.includes('b23.tv');
}

export const isBaiduVideoUrl = (url:any)=>{
    if (!url)return false;
    if (!isString(url))return false;
    return url.includes('https://pan.baidu.com/pfile/video');
}

/**
 * 是否是支持视频注记的url
 * @param szUrl
 */
export const isSupportVideoAnnoUrl = (szUrl:any)=>{
    return isYoutubeUrl(szUrl) || isBilibiliUrl(szUrl) || isBaiduVideoUrl(szUrl);
}

export const isSupportVideoType = (szType:any)=>{
    return szType == 'bilibili' || szType == 'youtube' || szType == 'baidu'
}

/**
 * block链接。。
 *
 * @param szUrl
 */
export const isCardBlockDeeplink = (szUrl)=>{
    return szUrl?.includes('blockid') && szUrl.includes('blocktype')
}

export const getTimeText = (timestamp: number) => {
    // 使用时间戳创建dayjs对象
    const dayjsObject = dayjs(timestamp);

    const hours = dayjsObject.hour().toString().padStart(2, "0");
    const minutes = dayjsObject.minute().toString().padStart(2, "0");
    const seconds = dayjsObject.second().toString().padStart(2, "0");
    return `${hours}:${minutes}:${seconds}`;
};

export function decodeArrayBuffer(arrayBuffer) {
    const encodings = ['utf-8', 'gbk', 'gb2312', 'big5'];

    for (const encoding of encodings) {
        try {
            const decoder = new TextDecoder(encoding);
            const content = decoder.decode(arrayBuffer);

            // 简单的有效性检查
            return content;
        } catch (error) {
            console.log(`编码 ${encoding} 解码失败`);
        }
    }

    // 如果都不行，使用默认UTF-8
    return new TextDecoder('utf-8').decode(arrayBuffer);
}


export function getYouTubeVideoUrl(embedUrl) {
    // 使用正则表达式从嵌入链接中提取视频 ID
    const regex = /(?:youtube-nocookie\.com\/embed\/|youtube\.com\/embed\/)([a-zA-Z0-9_-]+)/;
    const match = embedUrl.match(regex);

    if (match && match[1]) {
        // 返回普通的视频链接
        return `https://www.youtube.com/watch?v=${match[1]}`;
    } else {
        return embedUrl;
    }
}
export function  getYouTubeThumbnailUrl(videoUrl) {
    const regex = /(?:https?:\/\/(?:www\.)?youtube\.com\/(?:[^\/\n\s]+\/\S+\/|\S+?v=|(?:v|e(?:mbed)?)\/|\S+?\/)([A-Za-z0-9_-]{11}))/;
    const match = getYouTubeVideoUrl(videoUrl).match(regex);

    if (match && match[1]) {
        const videoId = match[1];  // 获取视频 ID
        const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/0.jpg`;
        return thumbnailUrl;
    } else {
        console.error("Invalid YouTube URL");
        return null;
    }
}

export function getYoutubeThumbImage(szVideoId:any,time){
    return new Promise(resolve => {
        const iframe = document.createElement("webview");
        iframe.src = 'https://www.youtube.com/embed/'+szVideoId;
        iframe.style.width = "560px"
        iframe.style.height = "551px"
        iframe.style.position = 'fixed';
        iframe.style.left = '0';
        iframe.style.top = '0';
        iframe.setAttribute("disablewebsecurity", "1")
        iframe.setAttribute("allowpopups", "")
        iframe.setAttribute("webpreferences", "contextIsolation=false")
        iframe.setAttribute(
            "sandbox",
            "allow-forms allow-modals allow-pointer-lock allow-same-origin allow-scripts",
        )

        iframe.addEventListener("new-window", (e) => {
            e.preventDefault()
        })

        iframe.addEventListener("dom-ready", async () => {
            setTimeout(()=>{
                resolve(iframe);
            },5000)

            await (iframe as WebviewTag).executeJavaScript(`
        const video = document.querySelector("video")
if (video) {
  video.currentTime = ${time};
  video.play();
  
  window.getSnapShot = () => {
      const video = document.querySelector("video");
      if (!video) return null;
    
      const canvas = document.createElement("canvas");
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      const url = canvas.toDataURL("image/png");
      
      canvas.remove();
      return url;
    }
}
                  
                `)
        })

        const div = document.createElement('div');
        div.appendChild(iframe);
        document.body.appendChild(div);
    })
}

export function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

/**
 * 是否在右侧栏
 */
export const isInSidebar = ()=>{
    return window.location.href.includes('sliderDraw');
}

export const isInPageCard = ()=>{
    return window.location.href.includes('/card');
}

/**
 * 释放URL
 * @param szUrl
 */
export function revokeBlobObjectURL (szUrl:any){
    if (!szUrl)return;
    if (szUrl.startsWith('blob://')){
        URL.revokeObjectURL(szUrl);
    }
}

export const getVideoSnapShotByVideo = (video:any) => {
    if (!video) return null;
    const canvas = document.createElement("canvas");
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    const ctx = canvas.getContext("2d");
    if (ctx){
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        const url = canvas.toDataURL("image/png");
        canvas.remove();
        return url;
    }
    return  null;
}

export const getVideoSnapShotByVideoId = (szVideoId:any) => {
    const video = document.getElementById(szVideoId);
    if (!video) return null;

    const canvas = document.createElement("canvas");
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    const ctx = canvas.getContext("2d");
    if (ctx){
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        const url = canvas.toDataURL("image/png");
        canvas.remove();
        return url;
    }
    return  null;
}

/**
 * 是否有infonotes选项
 * @param szType
 */
export const hasInfoNotes = (szType)=>{
    return szType == 'webLink' || szType == 'pdf' || szType == 'video' || szType == 'audio' || szType == 'project' || szType == 'image';
}

export function isValidYYYYMMDD(str: string) {
    if (!/^\d{8}$/.test(str)) return false;

    const year = parseInt(str.slice(0, 4), 10);
    const month = parseInt(str.slice(4, 6), 10);
    const day = parseInt(str.slice(6, 8), 10);

    const date = new Date(year, month - 1, day);

    return (
        date.getFullYear() === year &&
        date.getMonth() === month - 1 &&
        date.getDate() === day
    );
}
export function yyyymmddToNoonTimestamp(dateStr) {
    if (!/^\d{8}$/.test(dateStr)) {
        throw new Error("日期格式必须是 YYYYMMDD");
    }

    const year = parseInt(dateStr.slice(0, 4), 10);
    const month = parseInt(dateStr.slice(4, 6), 10) - 1; // JS 月份从 0 开始
    const day = parseInt(dateStr.slice(6, 8), 10);

    // 设置为当天的 12:00:00
    const date = new Date(year, month, day, 12, 0, 0, 0);
    return date.getTime();
}
export function getDueDateValue() {
    const currentNoteName = sessionStorage.getItem('currentNoteName')
    let defaultDuedate
    if (currentNoteName && isValidYYYYMMDD(currentNoteName)) {
        defaultDuedate = yyyymmddToNoonTimestamp(currentNoteName)
    } else {
        defaultDuedate = 0
    }
    console.log(1111,defaultDuedate);

    return defaultDuedate
}

export function parseVideoTranscript(text) {
    const sections = [];
    const lines = text.split('\n');
    let currentSection = null;

    for (const line of lines) {
        const lineTrimmed = line.trim();

        // 跳过空行和只有·的行
        if (!lineTrimmed || lineTrimmed === '·') continue;

        // 检测时间戳行（格式：00:00:00标题）
        const timestampMatch = lineTrimmed.match(/^(\d{2}:\d{2}:\d{2})\s*(.+)$/);

        if (timestampMatch) {
            // 如果已经有当前章节，先保存
            if (currentSection && currentSection.content.length > 0) {
                sections.push(currentSection);
            }

            // 创建新章节
            currentSection = {
                timestamp: timestampMatch[1],
                title: timestampMatch[2].trim(),
                content: [],
                text:''
            };
        } else if (currentSection) {
            // 处理内容行（兼容多种格式）
            let contentLine = lineTrimmed;

            // 移除开头的·符号和可能跟随的空格
            if (contentLine.startsWith('·')) {
                contentLine = contentLine.substring(1).trim();
            }

            // 移除其他可能的项目符号
            contentLine = contentLine.replace(/^[•▪➢›]\s*/, '').trim();

            // 跳过空内容
            if (contentLine) {
                currentSection.content.push(contentLine);
                currentSection.text += contentLine + '\n';
            }
        }
    }

    // 添加最后一个章节
    if (currentSection && currentSection.content.length > 0) {
        sections.push(currentSection);
    }

    return sections;
}

export function getItem(
  label: React.ReactNode,
  key?: React.Key | null,
  icon?: React.ReactNode,
  children?: MenuItem[],
  type?: 'group',
  onClick?:any,
  disabled?:any
): MenuItem {
  return {
    key,
    icon,
    children,
    label,
    type,
    onClick,
      disabled
  } as MenuItem;
}


